<script setup>
import { ref } from 'vue';
import { onErrorCaptured } from 'vue';

defineOptions({
  inheritAttrs: false
});

const emits = defineEmits(['onError']);

const props = defineProps({
  propagate: {
    type: Boolean,
    default: true
  }
})

const error = ref(null);

function reset() {
  error.value = null;
}

onErrorCaptured((e, component, info) => {
  console.warn(info, e);
  error.value = e;

  emits('onError', e, component, info);

  return props.propagate;
})

defineExpose({ reset })
</script>

<template>
  <slot v-if="!error" :error :attrs="$attrs"></slot>
  <slot v-else name="fallback" :error="error" :attrs="$attrs"></slot>
</template>
